import React from "react";


function AboutMe() {
    return (
        <div className="aboutme">
    <h4>
    Hi! My name is Dhananjhay Bansal and I recently graduated from the University of Alberta with an Honours Bachelor of Science degree in Astrophysics. I am currently a junior astrophysicist research officer at National Research Council of Canada, Herzberg Astrophysics Research Center, working on the upcoming CASTOR telescope mission.
    </h4>
    </div>
    )
}

export default AboutMe;